import React, { createContext, useEffect, useReducer } from "react"

const INITIAL_STATE ={
    showHot: false || null,
    showLosers: false || null,
    showGainers: false || null,
    showFavorites: false || null,
    showNewListings: false || null,
}

export const SwitchACtiveContext = createContext(INITIAL_STATE)

const SwitchACtiveReducer = ( state, action ) =>{
    switch(action.type){

        case "SHOW_HOT":
            return {
                showHot: true,
                showLosers: false,
                showGainers: false,
                showFavorites: false,
                showNewListings: false,
                
            }
         case "SHOW_LOSERS":
            return {
                showHot: false,
                showLosers: true,
                showGainers: false,
                showFavorites: false,
                showNewListings: false,
                
         }

         case "SHOW_GAINERS":
            return {
                showHot: false,
                showLosers: false,
                showGainers: true,
                showFavorites: false,
                showNewListings: false,
                
         }
         case "SHOW_FAVORITES":
            return {
                showHot: false,
                showLosers: false,
                showGainers: false,
                showFavorites: true,
                showNewListings: false,
                
         }
         case "SHOW_NEWLISTINGS":
            return {
                showHot: false,
                showLosers: false,
                showGainers: false,
                showFavorites: false,
                showNewListings: true,
                
         }
         default:
            return state

       }
}
export const SwitchACtiveContextProvider = ({children}) =>{
    const [ state, dispatch ] = useReducer(SwitchACtiveReducer, INITIAL_STATE)
    return(
        <SwitchACtiveContext.Provider value={{showHot:state.showHot,showLosers:state.showLosers,showGainers:state.showGainers,showFavorites:state.showFavorites,showNewListings:state.showNewListings, loading: state.loading , dispatch}}>
            {children}
        </SwitchACtiveContext.Provider>
    )
}
